import { Platform } from 'react-native'
import { MenuDrawer } from './menu.drawer'
import { MenuDropdown } from './menu.dropdown'
import { useIsMobileDevice } from '../../../hooks/is-mobile.hook'
import type { MenuProps } from './menu.types'

export function Menu(props: MenuProps) {
  const isMobile = useIsMobileDevice()

  if (Platform.OS === 'web' && !isMobile) {
    return <MenuDropdown {...props} />
  }

  return (
    <>
      {props.anchor}
      <MenuDrawer
        visible={props.visible}
        onDismiss={props.onDismiss}
        sections={props.sections}
      />
    </>
  )
}
